// extracted by mini-css-extract-plugin
export default {"monthlyChart":"monthly-chart_monthlyChart__LrvXt"};